import React from 'react';
import {
   Modal,
   Box,
   Typography,
   TextField,
   Button,
   IconButton
} from '@mui/material';
import { FluxIcon } from '@meltwater/flux-web-components-react';
import styles from './admin.module.css';
import PermissionsSection from './PermissionsSection';
import GroupsSection from './GroupsSection';

/**
 * Add User Modal Component
 * Modal for adding new users with permissions and groups
 */
const AddUserModal = ({
   open = false,
   onClose,
   onSubmit,
   userInput = '',
   onInputChange,
   groups = [],
   GSDgroups = [],
   onGroupsChange,
   permission = [],
   onPermissionChange,
   sendgridPermission = [],
   onSendgridPermissionChange,
   mediaRelationsPermission = [],
   onMediaRelationsPermissionChange,
   companiesPermission = [],
   onCompaniesPermissionChange,
   dashboardPermission = [],
   onDashboardPermissionChange,
   twitterXPermission = [],
   onTwitterXPermissionChange,
   entitlementPermission = [],
   onEntitlementPermissionChange,
   intercomPermission = [],
   onIntercomPermissionChange,
   toolsPermission = [],
   onToolsPermissionChange,
   auth0Permission = [],
   onAuth0PermissionChange,
   scriptRunnerv2Permission = [],
   onScriptRunnerv2PermissionChange,
   isLoading = false
}) => {
   return (
      <Modal
         open={open}
         onClose={onClose}
         aria-labelledby="add-user-modal-title"
         aria-describedby="add-user-modal-description"
      >
         <Box className={styles.modalContainer}>
            <div className={styles.modalHeader}>
               <Typography variant="h6" component="h2" className={styles.modalTitle}>
                  Add New User
               </Typography>
               <IconButton onClick={onClose} size="small" className={styles.closeButton}>
                  <FluxIcon name="actions:close" />
               </IconButton>
            </div>

            <div className={styles.modalContent}>
               {/* Email Field */}
               <TextField
                  label="Email"
                  type="email"
                  fullWidth
                  value={userInput}
                  onChange={onInputChange}
                  required
                  variant="outlined"
                  size="small"
                  placeholder="user@example.com"
                  helperText="Enter a valid email address"
                  sx={{ mb: 2 }}
               />

               {/* Groups section */}
               <GroupsSection
                  groups={groups}
                  GSDgroups={GSDgroups}
                  onGroupsChange={onGroupsChange}
                  disabled={false}
               />

               {/* Permissions */}
               <Typography variant="subtitle2" className={styles.sectionTitle} sx={{ mt: 1 }}>
                  Permissions
               </Typography>
               <PermissionsSection
                  permission={permission}
                  onPermissionChange={onPermissionChange}
                  dashboardPermission={dashboardPermission}
                  onDashboardPermissionChange={onDashboardPermissionChange}
                  sendgridPermission={sendgridPermission}
                  onSendgridPermissionChange={onSendgridPermissionChange}
                  mediaRelationsPermission={mediaRelationsPermission}
                  onMediaRelationsPermissionChange={onMediaRelationsPermissionChange}
                  companiesPermission={companiesPermission}
                  onCompaniesPermissionChange={onCompaniesPermissionChange}
                  twitterXPermission={twitterXPermission}
                  onTwitterXPermissionChange={onTwitterXPermissionChange}
                  entitlementPermission={entitlementPermission}
                  onEntitlementPermissionChange={onEntitlementPermissionChange}
                  intercomPermission={intercomPermission}
                  onIntercomPermissionChange={onIntercomPermissionChange}
                  toolsPermission={toolsPermission}
                  onToolsPermissionChange={onToolsPermissionChange}
                  auth0Permission={auth0Permission}
                  onAuth0PermissionChange={onAuth0PermissionChange}
                  scriptRunnerv2Permission={scriptRunnerv2Permission}
                  onScriptRunnerv2PermissionChange={onScriptRunnerv2PermissionChange}
                  disabled={false}
               />
            </div>

            <div className={styles.modalFooter}>
               <Button
                  variant="contained"
                  color="primary"
                  onClick={onSubmit}
                  className={styles.primaryButton}
                  disabled={isLoading}
               >
                  Add User
               </Button>
            </div>
         </Box>
      </Modal>
   );
};

export default AddUserModal;
